import React, { createContext, useContext, useState, useEffect } from 'react';
import conductorApi from '../lib/conductorApi';

const ConductorAuthContext = createContext(null);

export const ConductorAuthProvider = ({ children }) => {
  const [conductor, setConductor] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem('conductor');
    const token = localStorage.getItem('conductor_token');
    if (stored && token) {
      setConductor(JSON.parse(stored));
    }
    setLoading(false);
  }, []);

  const login = async (rut, password) => {
    const response = await conductorApi.post('/auth/login-conductor', { rut, password });
    const { token, conductor: data } = response.data;
    localStorage.setItem('conductor_token', token);
    localStorage.setItem('conductor', JSON.stringify(data));
    setConductor(data);
    return data;
  };

  const logout = () => {
    localStorage.removeItem('conductor_token');
    localStorage.removeItem('conductor');
    setConductor(null);
  };

  const refresh = async () => {
    try {
      const response = await conductorApi.get('/conductor/me');
      localStorage.setItem('conductor', JSON.stringify(response.data));
      setConductor(response.data);
      return response.data;
    } catch {
      return null;
    }
  };

  return (
    <ConductorAuthContext.Provider value={{ conductor, login, logout, refresh, loading }}>
      {children}
    </ConductorAuthContext.Provider>
  );
};

export const useConductorAuth = () => {
  const context = useContext(ConductorAuthContext);
  if (!context) {
    throw new Error('useConductorAuth must be used within ConductorAuthProvider');
  }
  return context;
};
